<template>

    <AppHead title="Sign in to Pager" />

    <AlertBox v-if="$page.props.flash.success || $page.props.flash.error" :message="$page.props.flash.success || $page.props.flash.error" :type="$page.props.flash.error ? 'error' : 'success'" />
    <div class="min-h-screen-ios min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8 sm:bg-gray-300 text-regal-blue-900">
       <div class="sm:mx-auto sm:w-full sm:max-w-lg">
           <div class="bg-white w-full rounded-3xl">
               <div class="min-w-screen flex flex-col items-center justify-center p-8 space-y-4">
                   <div class="w-full flex flex-col items-center justify-center pb-4 space-y-2">
                       <div class="text-3xl font-bold tracking-tight">
                           Get started
                       </div>
                       <div class="text-center font-medium text-gray-800">
                           We suggest using the email address you use at <span class="font-bold">work</span>.
                       </div>
                   </div>
                   <a :href="authProviderUrls.google" class="focus:ring-regal-blue-700 inline-flex items-center text-gray-800 border border-gray-500 justify-center w-full rounded-lg font-medium py-2 px-4 pr-8 transition-colors duration-150 ease-in-out hover:bg-gray-300 active:border-gray-600 active:bg-gray-400 hover:text-regal-blue-900">
                       <span class="flex rounded-lg items-center justify-center w-10 h-10 mr-1">
                           <svg class="c-button__icon" width="18" height="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><g><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path><path fill="none" d="M0 0h48v48H0z"></path></g></svg>
                       </span>
                       Sign In with Google
                   </a>
                   <a :href="authProviderUrls.apple" class="focus:ring-regal-blue-700 inline-flex items-center text-gray-800 border border-gray-500 justify-center w-full rounded-lg font-medium py-2 px-4 pr-8 transition-colors duration-150 ease-in-out hover:bg-gray-300 active:border-gray-600 active:bg-gray-400 hover:text-regal-blue-900">
                       <span class="flex rounded-lg items-center justify-center w-10 h-10 mr-1">
                           <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true"><g><path d="M16.365 1.43c0 1.14-.493 2.27-1.177 3.08-.744.9-1.99 1.57-2.987 1.57-.12 0-.23-.02-.3-.03-.01-.06-.04-.22-.04-.39 0-1.15.572-2.27 1.206-2.98.804-.94 2.142-1.64 3.248-1.68.03.13.05.28.05.43zm4.565 15.71c-.03.07-.463 1.58-1.518 3.12-.945 1.34-1.94 2.71-3.43 2.71-1.517 0-1.9-.88-3.63-.88-1.698 0-2.302.91-3.67.91-1.377 0-2.332-1.26-3.428-2.8-1.287-1.82-2.323-4.63-2.323-7.28 0-4.28 2.797-6.55 5.552-6.55 1.448 0 2.675.95 3.6.95.865 0 2.222-1.01 3.902-1.01.613 0 2.886.06 4.374 2.19-.13.09-2.383 1.37-2.383 4.19 0 3.26 2.854 4.42 2.955 4.45z"></path></g></svg>            </span>
                           Sign In with Apple
                   </a>
                   <div class="flex w-full items-center py-2">
                       <div class="h-0.5 bg-gray-400 flex-1 rounded-full">
                       </div>
                       <div class="w-12 text-center text-gray-700 font-medium">
                           OR
                       </div>
                       <div class="h-0.5 bg-gray-400 flex-1 rounded-full">

                       </div>
                   </div>
                   <div class="w-full pb-2">
                       <form @submit.prevent="form.post(route('login.process'))" class="flex flex-col justify-center w-full space-y-4">
                           <input type="email" v-model="form.email" name="email" class="w-full rounded-lg border-gray-500 py-3 focus:outline-none focus:border-regal-blue-700 focus:ring-regal-blue-700 placeholder-gray-600" placeholder="name@work-email.com" required>
                           <InlineError v-if="form.errors.email" :message="form.errors.email"/>
                           <button type="submmit" class="w-full rounded-lg bg-regal-blue-700 text-white py-3 font-medium" name="button">Sign In with Email</button>
                       </form>
                   </div>
                   <div class="w-full flex items-center space-x-1 text-center justify-center text-sm font-medium text-gray-800">
                       <svg class="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"></path></svg>
                       <div class="">
                           New to Pager? <a href="#" class="underline text-regal-blue-600">Create an account</a>
                       </div>
                   </div>
               </div>
           </div>

       </div>
   </div>

</template>

<script>
    import { useForm } from '@inertiajs/inertia-vue3'
    import InlineError from '@/Shared/InlineError'
    import AlertBox from '@/Shared/AlertBox'

    export default {
        setup () {
            const form = useForm({
                email: null,
            })

            return { form }
        },
        components: { InlineError, AlertBox },
        props: {
            email: Object,
        }
    }
</script>
